import { PhoneNumber } from "../types/phoneNumber"
import { StringFormatter } from "./stringFormatter"

/**
 *  A formatter for the phone number to be formatted in international format.
 *  This format is the standard international format.
 *
 *  @example
 *  Dutch format: `+31 612345678`
 */
export class PhoneNumberInternationalFormatter extends StringFormatter<PhoneNumber> {
  protected convert(input: PhoneNumber): string {
    return `${input.prefix} ${input.number}`
  }
}
